<template>
	<section class="con-1200 box-white mt-30px">
		<div class="padding_section">
			<h2 class="fs-title text-center">Forduljon hozzánk bizalommal</h2>
			<div class="fs-desc text-center mb-30px">
				Kérdése merült fel, vagy tanácsot szeretne kérni? Kérjen visszahívást és kollégánk hamarosan felkeresi.
			</div>

			<ValidationObserver ref="form" v-slot="{ invalid, handleSubmit }" slim>
				<div class="form contact_form">
					<div class="col-w50-left mb-30px">
						<ValidationProvider
							name="Vezetéknév"
							rules="required|letter_space_hypens"
							v-slot="{ errors, classes }"
							slim
						>
							<div :class="classes">
								<input
									type="text"
									name="last_name"
									placeholder="Vezetéknév"
									class="w-100 field"
									v-model="message.last_name"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-right mb-30px">
						<ValidationProvider
							name="Keresztnév"
							rules="required|letter_space_hypens"
							v-slot="{ errors, classes }"
							slim
						>
							<div :class="classes">
								<input
									type="text"
									name="first_name"
									placeholder="Keresztnév"
									class="w-100 field"
									v-model="message.first_name"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-left mb-30px">
						<ValidationProvider name="E-mail cím" rules="required|email" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="email"
									name="email"
									placeholder="E-mail cím"
									class="w-100 field"
									v-model="message.email"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="col-w50-right mb-30px" style="margin-right: 0px">
						<ValidationProvider name="Telefonszám" rules="required|phone" v-slot="{ errors, classes }" slim>
							<div :class="classes">
								<input
									type="text"
									name="phone"
									placeholder="Telefonszám"
									class="w-100 field"
									v-model="message.phone"
									data-hj-allow
								/>
							</div>
							<span class="error_message">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>

					<ValidationProvider name="Üzenet" rules="required" v-slot="{ errors, classes }" slim>
						<div :class="classes">
							<textarea
								name="message"
								cols="30"
								rows="10"
								placeholder="Üzenet"
								class="field textarea"
								v-model="message.text"
								:class="classes"
							></textarea>
						</div>
						<span class="error_message">{{ errors[0] }}</span>
					</ValidationProvider>

					<div class="d-flex flex-column">
						<div class="d-flex flex-m-column">
							<ValidationProvider
								name="Adatkezelési tájékoztató"
								:rules="{ required: { allowFalse: false } }"
								v-slot="{ errors, classes }"
								slim
							>
								<div class="d-flex flex-column col-w50-chbox col-w50-left">
									<div class="d-flex flex-column w-100">
										<div
											:class="classes"
											class="d-flex chbox_style-wrapper mt-30px mb-30px mt-m-15px mb-m-15px checkbox-field"
										>
											<input
												type="checkbox"
												class="field"
												v-model="message.data_protection"
												id="privacyPolicy"
												data-hj-allow
											/>
											<span class="chbox_style"></span>
											<label for="privacyPolicy">
												Elolvastam és elfogadom az
												<a href="/adatvedelem" target="_blank">Adatkezelésről</a>
												<br />
												szóló tájékoztatóban foglaltakat.
											</label>
										</div>
									</div>
									<span class="error_message">
										{{ errors[0] }}
									</span>
								</div>
							</ValidationProvider>
							<ValidationProvider name="Hírlevel" slim>
								<div
									class="col-w50-chbox chbox_style-wrapper mt-30px mb-30px mt-m-15px mb-m-15px checkbox-field"
								>
									<input
										type="checkbox"
										class="field"
										v-model="message.subscribe"
										id="newsletter"
										data-hj-allow
									/>
									<span class="chbox_style"></span>
									<label for="newsletter">
										Hozzájárulok, hogy az Eurorisk Kft. a szolgáltatásaival kapcsolatos hírlevelet
										küldjön a részemre.
									</label>
								</div>
							</ValidationProvider>
						</div>
						<div class="d-flex justify-center error_message error_message--broke" v-if="errors">
							<ul class="list-style-none">
								<li class="text-center" v-for="error in errors" :key="uuid(error)">
									{{ error }}
								</li>
							</ul>
						</div>
						<span class="d-flex justify-center success_message" v-if="success">
							{{ success }}
						</span>

						<button class="btn btn-blue m-auto" :disabled="invalid" @click="handleSubmit(handleSend)">
							Visszahívást kérek!
						</button>
					</div>
				</div>
			</ValidationObserver>
		</div>
	</section>
</template>

<script>
import laravelErrorParse from '@/helpers/laravelErrorParse';
import { mapActions } from 'vuex';

import { v5 as uuidv5 } from 'uuid';

// outside of the component:
function initialState() {
	return {
		message: {
			last_name: null,
			first_name: null,
			email: null,
			phone: null,
			text: null,
			data_protection: false,
			subscribe: false,
		},
		success: null,
		errors: null,
	};
}

export default {
	data: function() {
		return initialState();
	},
	methods: {
		...mapActions(['sendMessage']),
		async handleSend() {
			const response = await this.sendMessage(this.$data.message);

			if (response.success) {
				this.clear();
				this.success = response.message;
				this.$refs.form.reset();
			} else {
				this.errors = laravelErrorParse(response);
			}
		},
		clear() {
			Object.assign(this.$data, initialState());
		},
		uuid(name) {
			return uuidv5(name, uuidv5.URL);
		},
	},
};
</script>
